import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TenancyContext } from '@core/tenancy';
import { TenantKey } from '@app/core/enums/tenant-key.enum';
import { START_ROUTES_SEGMENTS } from '../enum/start-routes-segments.enum';
import { ProbateRotateSegments } from '@app/probate/shared/enums';

@Injectable({ providedIn: 'root' })
export class ProbateStartNavigationService {
  private readonly _tenancy = inject(TenancyContext);
  private readonly _router = inject(Router);

  public goToWillEstate() {
    this._router.navigate([
      this._tenancy.link(
        TenantKey.PROBATE,
        ProbateRotateSegments.start,
        START_ROUTES_SEGMENTS.willEstate,
      ),
    ]);
  }

  public goToAccount() {
    this._router.navigate([
      this._tenancy.link(
        TenantKey.PROBATE,
        ProbateRotateSegments.start,
        START_ROUTES_SEGMENTS.account,
      ),
    ]);
  }

  public gotoOutOfJurisdiction() {
    this._router.navigate([
      this._tenancy.link(
        TenantKey.PROBATE,
        ProbateRotateSegments.start,
        START_ROUTES_SEGMENTS.outOfJurisdiction,
      ),
    ]);
  }

  public goToConfirmation() {
    this._router.navigate([
      this._tenancy.link(
        TenantKey.PROBATE,
        ProbateRotateSegments.start,
        START_ROUTES_SEGMENTS.confirmation,
      ),
    ]);
  }
}
